import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface LeadPremiumEnrichResponse {
  lead: Lead;
}

const postLeadPremiumEnrich = async (
  authToken: string,
  leadId: string
): Promise<LeadPremiumEnrichResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${encodeURIComponent(leadId)}/premium-enrich`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadPremiumEnrich;
